<pay-club-applet-ui-dialog-btm-sheet
  [title]="'اسکن کن، پرداخت کن ، ۵۰ تا سکه بگیر'"
  [closeable]="true"
  [titleRight]="true"
>
  <div
    class="content"
    body
  >
    <p class="description">
      شما می‌توانید در طول ماه با استفاده از قسمت بارکد در اپلیکیشن دیجی‌پی، در
      <strong>مراکز و فروشگاه‌های طرف قرارداد دیجی‌پی</strong> اقدام به پرداخت فاکتور خرید خود فرمایید و به ازای هر تراکنش، ۵۰ سکه دریافت
      کنید.
    </p>
    <div class="note-wrapper">
      <div class="title">نحوه‌ی دریافت امتیاز</div>
      <div class="note-explanation">
        با مراجعه مراکز و فروشگاه‌های طرف قرداد با دیجی‌پی، و اسکن و پرداخت فاکتور خرید از طریق بخش بارکد اپلیکیشن
      </div>
    </div>
  </div>
</pay-club-applet-ui-dialog-btm-sheet>
